import { graphql } from '@/generated/gql';

export const DEMAND_CASES_RELEASE_MUTATION = graphql(/* GraphQL */ `
  mutation DemandCasesBatchRelease($id: UUID!, $data: TsrctReleaseNegotiationCasesInput!) {
    tesseract {
      demand(id: $id) {
        releaseNegotiationCases(data: $data)
      }
    }
  }
`);
